module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/invoices/modals/copy-invoice-to-qb-or-xero/copy-invoice-to-qb-or-xero.modal.scss
// module id = ./web/modern/components/invoices/modals/copy-invoice-to-qb-or-xero/copy-invoice-to-qb-or-xero.modal.scss
// module chunks = 0